// extracted by mini-css-extract-plugin
module.exports = {"pickContainer2":"TicketsV1_pickContainer2__Bu1wr","breadContain":"TicketsV1_breadContain__1f28g","price":"TicketsV1_price__2Cm4F","page":"TicketsV1_page___HMiv"};